export default {
	cinema: {
		address: 'ул. Ленина, д. 3а',
		place: null,
		phoneNumbers: ['+7 (48444) 6-59-40'],
		facebook: null,
		instagram: null,
		vk: 'https://vk.com/kino_dvoretc_kultury',
		twitter: null,
		odnoklassniki: null,
		youtube: null,
		app: {
			appstore: null,
			googleplay: null,
		},
		payment: {
			active: true,
			card: ['mir', 'visa', 'mastercard', 'maestro', 'sbp', 'sberpay'],
		},
		maps: 'https://yandex.ru/maps/-/CCbtqO0R',
		selectButton: {
			options: [],
			selectedOptionValue: null,
		},
		soonPageIsEnabled: false,
		saleRules: false,
		details: false,
	},
	feedback: true,
};
